import {
  BuildVenueToVersionSetCommand,
  BuildVenueToVersionSetCommandInput,
  GetProductionBuildInfoCommand,
  GetProductionBuildInfoCommandOutput,
} from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';
import { callApi } from '../client';

export const buildForVenue = async (
  venue: string,
  conference: string,
  versionSet: string,
  dryRun: boolean,
  token: string
): Promise<string | undefined> => {
  const input: BuildVenueToVersionSetCommandInput = {
    venue,
    conference,
    versionSet,
    dryRun,
  };
  const command = new BuildVenueToVersionSetCommand(input);
  const response = await callApi(command, token);
  return response.concertRequestId;
};

export const getProductionBuildInfo = async (
  concertRequestId: string,
  token: string
): Promise<GetProductionBuildInfoCommandOutput> => {
  const command = new GetProductionBuildInfoCommand({ concertRequestId });
  return callApi(command, token);
};
